/**
 * analyticsMiddleware — fires before/after each command dispatch.
 *
 * Logs start / done / fail with the command name, the correlation id and the
 * elapsed time, so the dispatch flow is visible during manual smoke tests.
 * Sending these to a product-analytics sink is a change to this file alone.
 */

import type { CommandMiddleware } from 'src/content/ChatV2/commands/ICommand';

export const analyticsMiddleware: CommandMiddleware = {
  name: 'analytics',
  async intercept(invocation, next) {
    const { command, context } = invocation;
    const tag = `[cmd:${command.name}:${context.correlationId}]`;

    // eslint-disable-next-line no-console
    console.log(`${tag} start`);
    const started = Date.now();

    try {
      const result = await next();
      // eslint-disable-next-line no-console
      console.log(`${tag} done in ${Date.now() - started}ms`);
      return result;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(`${tag} fail in ${Date.now() - started}ms`, error);
      throw error;
    }
  }
};
